module.exports = __webpack_public_path__ + "static/img/eclesial-ecologica.5c148b31.png";